"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownCircle = _interopRequireDefault(require("./IconChevronDownCircle"));
var IconChevronLeftCircle = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownCircle.default).withConfig({
  displayName: "IconChevronLeftCircle",
  componentId: "c11n-8-107-0__sc-b0cs55-0"
})(["transform:rotate(90deg);"]);
var _default = IconChevronLeftCircle;
exports.default = _default;